export const INVALID_EMAIL_MSG = 'The email is not valid';
export const DEFAULT_ERROR_MSG = 'Something went wrong';
export const EMAIL_IS_NOT_UNIQUE_MSG = 'This email is already a member';
export const PASSWORD_NOT_VALID =
  'Use 10 or more characters with a mix of upper and lowercase letters, numbers, & symbols';
export const PASSWORDS_DONT_MATCH = "Passwords don't match";
